<template>
  <div class="critical-error-page flex flex--center--center">
    <div class="content critical-error-page__content">
      <img class="content__image" src="@/assets/images/critical-error.svg" alt="logo" />
      <div class="content__title">{{ $t(title) }}</div>
      <div class="content__message">
        {{ $t(message) }}
      </div>
      <div class="buttons critical-error-page__buttons flex flex--justify-center">
        <app-button inverted @click="onGoToWebshop">{{
          $t('errorPage.button.returnToWebshop')
        }}</app-button>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/common/AppButton.vue';

export default {
  name: 'CriticalErrorPage',
  components: { AppButton },
  props: {
    title: {
      type: String,
      default: 'common.errorLabel'
    },
    message: {
      type: String,
      default: 'errorPage.errorMessage'
    },
    doctorSlug: {
      type: String,
      required: true
    },
    hashedDataId: {
      type: String,
      required: true
    }
  },
  methods: {
    onGoToWebshop() {
      this.$router.push({
        name: 'WelcomePage',
        params: {
          doctorSlug: this.doctorSlug,
          hashedDataId: this.hashedDataId
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/colors';

.critical-error-page {
  text-align: center;
  color: $tuatara-color;
  height: 98vh;
}

.content {
  width: 490px;
  max-width: 100%;

  &__image {
    width: 65px;
  }

  &__title {
    margin-top: 32px;
    font-size: 4rem;
    line-height: 5.1rem;
  }

  &__message {
    font-size: 1.6rem;
    line-height: 2.5rem;
    margin-top: 24px;
    margin-bottom: 32px;
  }

  &__buttons {
    width: 490px;
    max-width: 100%;
  }
}
</style>
